var BASE_MEETINGS_KEY = 'meetings';
var MY_UPCOMING_KEY = 'myUpcoming';
var meetingsKeys = {
  myUpcoming: [BASE_MEETINGS_KEY, MY_UPCOMING_KEY]
};
export default meetingsKeys;